import { render, staticRenderFns } from "./roleManageList.vue?vue&type=template&id=193418a6&scoped=true"
import script from "./roleManageList.vue?vue&type=script&lang=js"
export * from "./roleManageList.vue?vue&type=script&lang=js"
import style0 from "./roleManageList.vue?vue&type=style&index=0&id=193418a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193418a6",
  null
  
)

export default component.exports